import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { rejectWithdrawRequest } from '../withdrawRequestsEndpoints'
import { withdrawRequestKeys } from '../withdrawRequestsQueryKeys'
import { fiatTransactionKeys } from '../../../fiatTransactions/api/fiatTransactionsQueryKeys'
import type { RejectWithdrawRequestInput } from '../../types/withdrawRequestsTypes'

export function useRejectWithdrawRequestMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: RejectWithdrawRequestInput) => rejectWithdrawRequest(input),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: withdrawRequestKeys.lists() })
      qc.invalidateQueries({ queryKey: withdrawRequestKeys.statusCounts() })
      qc.invalidateQueries({ queryKey: withdrawRequestKeys.detail(vars.id) })
      qc.invalidateQueries({ queryKey: fiatTransactionKeys.lists() })
    },
  })
}
